import React, { useContext } from 'react';

import { Link } from '@reach/router';
import { isMobile } from 'react-device-detect';

import { GlobalContext } from '../../../store';
import { IAdminEvent } from '../../../store/admin/events/store';

import { menuIcon, redWaglLogo } from '../../../assets/images/';
import userIcon from '../../../assets/images/player-blank.svg';
import { getEventVerboseDate } from '../../../scenes/admin/Common/Subheader/Utils/getEventVerboseDate';
import { useBoolean } from '../../../scenes/common/Hooks/useBoolean.hook';
import Button from '../../Button';
import { AdminSideMenu } from './Components/AdminSideMenu/AdminSideMenu';
import { CookiesBanner } from './Components/CookiesBanner/CookiesBanner';
import { PX } from '../../../contrib/ui';

interface IProps {
  clubId: number;
  eventId: number | undefined;
}

const AdminHeader = (props: IProps) => {
  const { clubId, eventId } = props;

  const { adminEvents } = useContext(GlobalContext);

  const [menuOpen, setMenuOpen, toggleMenuOpen] = useBoolean(false);

  const closeMenu = () => setMenuOpen(false);

  const event: IAdminEvent | undefined = adminEvents[Number(eventId)] || undefined;

  return (
    <>
      <div className={`admin-header`}>
        <CookiesBanner />

        <div className="admin-header-wrap">
          <Button
            color="primary"
            className="menu"
            aria-haspopup="true"
            id="toggle-menu"
            onClick={toggleMenuOpen}
          >
            <img
              src={menuIcon}
              className="player-header-icon override"
              height={25 * PX}
              width={25 * PX}
              alt="Menu"
            />
          </Button>

          {event && (
            <div className="center">
              <span className="title">{event.name.toUpperCase()}</span>
              {!isMobile && <span className="subtitle">{getEventVerboseDate(event)}</span>}
            </div>
          )}

          {isMobile ? (
            <Link className="admin-header-logo" to="/profile/settings">
              <img src={userIcon} className="admin-header-logo__img" alt="Logo" />
            </Link>
          ) : (
            <Link className="admin-header-logo" to="/staff">
              <img src={redWaglLogo} className="admin-header-logo__img" alt="Logo" />
            </Link>
          )}
        </div>
      </div>

      <AdminSideMenu clubId={Number(clubId)} onClose={closeMenu} open={menuOpen} />
    </>
  );
};

export { AdminHeader };
